import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend, BarElement
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import ResponsiveStack from "../utils/responsive-stack";
import Button from "@mui/material/Button";
import CenterDiv from "../utils/center-div";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement
);

const AttendanceStatisticsChart = ({ chartData, filter, handleFilter }) => {

    const data = {
        labels: chartData.labels,
        datasets: chartData.datasets.map(dataset => ({
            ...dataset,
            borderWidth: 2,
            fill: true,
            tension: 0.3, // smooth curve
            backgroundColor: getBackgroundColor(dataset.label),
            borderColor: getBorderColor(dataset.label),
        })),
    };

    return (
        <div>
            <Bar
                data={data}
                options={{
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: `Finance Statistics (by ${filter})`,
                        },
                    },
                }}
            />

            <CenterDiv>
                <ResponsiveStack>
                    {
                        filter !== "year" ?
                            <Button onClick={() => handleFilter('year')}>
                                Year
                            </Button>
                            :
                            null
                    }

                    {
                        filter !== "month" ?
                            <Button onClick={() => handleFilter('month')}>
                                Month
                            </Button>
                            :
                            null
                    }


                    {
                        filter !== "day" ?
                            <Button onClick={() => handleFilter('day')}>
                                day
                            </Button>
                            :
                            null
                    }

                </ResponsiveStack>
            </CenterDiv>
        </div>
    )
};

const getBackgroundColor = (label) => {
    switch (label) {
        case 'OFFERING':
            return 'rgba(75, 192, 192, 0.2)';
        case 'THANKSGIVING':
            return 'rgba(255, 99, 132, 0.2)';
        case 'TITHE':
            return 'rgba(255, 206, 86, 0.2)';
        default:
            return 'rgba(153, 102, 255, 0.2)';
    }
};

const getBorderColor = (label) => {
    switch (label) {
        case 'OFFERING':
            return 'rgba(75, 192, 192, 1)';
        case 'THANKSGIVING':
            return 'rgba(255, 99, 132, 1)';
        case 'TITHE':
            return 'rgba(255, 206, 86, 1)';
        default:
            return 'rgba(153, 102, 255, 1)';
    }
};

export default AttendanceStatisticsChart;
